import React from 'react';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import Markdown from '@repo/ui/src/components/Markdown';
import ProTipPigIcon from '@repo/ui/src/components/Icons/ProTipPigIcon';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { LinkProps } from '@typings/index';

type ProTipProps = {
  tip: string;
  link?: LinkProps;
};

const ProTip = ({ tip, link }: ProTipProps) => {
  const { t } = useTranslation();
  return (
    <div className="w-full col-span-2 bg-warm-200 flex flex-col sm:flex-row items-start sm:items-center py-6 px-10 mt-4">
      <div className="flex flex-row sm:flex-col items-center w-full sm:w-fit sm:shrink-0">
        <ProTipPigIcon className="w-12 sm:w-full" />
        <span className="tra-text-web-sub-2 ml-2 sm:ml-0 mt-0 font-semibold text-gray-800">
          {t('recipeContent.proTip', undefined, { default: 'Pro Tip' })}
        </span>
      </div>

      <div className="w-full sm:w-[3px] h-[3px] sm:h-auto sm:self-stretch bg-brand-300 sm:mx-10 mt-2 sm:mt-0" />

      <div className="flex-1 mt-4 sm:mt-0">
        <Markdown
          className="text-gray-900 "
          bodySize="large"
          components={{
            a: (elProps: any) => {
              const isInternal = elProps.href?.startsWith('/') || elProps.href?.startsWith('#');
              return (
                <Anchor
                  className="tra-text-web-link hover:text-brand-500"
                  externalLink={!isInternal ? elProps.href : undefined}
                  link={isInternal ? elProps.href : undefined}
                  isExternal={!isInternal}
                  {...elProps}
                />
              );
            },
          }}
        >
          {tip}
        </Markdown>
        {link?.displayName && (
          <div className="mt-3">
            <Button variant={ButtonVariant.knife} as={Anchor} size="small" {...link}>
              {link.displayName}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProTip;
